import { configureStore } from "@reduxjs/toolkit";
import securityReducer from "./security";

import seoReducer from "../reducers/Admin/seoActions";
import qaReducer from "../reducers/Admin/qaActions";
import documentReducer from "../reducers/Admin/documentActions";
import clientReducer from "../reducers/Admin/clientActions";
import teamReducer from "../reducers/Admin/teamActions";
import blogReducer from "../reducers/Admin/blogActions";
import caseStudyReducer from "../reducers/Admin/caseStudyActions";
import contactFormReducer from "../reducers/Admin/contactFormActions";
import roleReducer from "../reducers/Admin/roleActions";
import userReducer from "../reducers/Admin/userActions";
import resourcesReducer from "../reducers/Admin/resourcesActions";
import testimonialsReducer from "../reducers/Admin/testimonialsActions";
import globalReducer from "../reducers/Site/globalActions";

const store = configureStore({
  reducer: {
    loggedUserReducer: securityReducer,
    seoReducer,
    qaReducer,
    documentReducer,
    clientReducer,
    blogReducer,
    caseStudyReducer,
    contactFormReducer,
    roleReducer,
    userReducer,
    testimonialsReducer,
    globalReducer,
    teamReducer,
    resourcesReducer,
  },
});

export default store;
